/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 16.04.13
 * Time: 15:11
 */

import { Constants_Offer } from "../Constants_Offer";
import { IOfferQuestCondition } from "./IOfferQuestCondition";
import { OfferQuestConditionLogicEnum } from "./OfferQuestConditionLogicEnum";
import { IPrivateOfferModel } from "./IPrivateOfferModel";

export class OfferQuestConditionContainer implements IOfferQuestCondition {
    private _logic: OfferQuestConditionLogicEnum;
    private _questConditions: Map<any, any>;
    private _modelData: IPrivateOfferModel;

    constructor(conditions: Object, privateOfferModel: IPrivateOfferModel) {
        this._modelData = privateOfferModel;
        this._questConditions = new Map<any, any>();

        this.parseQuestConditionList(conditions);
    }

    private parseQuestConditionList(conditions: any): void {
        let offerQuestCondition: IOfferQuestCondition;
        for (let i: number = 0; i < conditions.length; ++i) {
            offerQuestCondition = this._modelData.createQuestCondition(conditions[i].name, conditions[i].params);
            if (offerQuestCondition) {
                this._questConditions.set(conditions[i].name, offerQuestCondition);
            }
        }
    }

    public get registerName(): string {
        return Constants_Offer.QUEST_CONDITION_CONTAINER;
    }

    public parseFromObjectParam(name: string, params: any): void {
        this._questConditions = new Map<any, any>();

        for (let i: number = 0; i < params.length; ++i) {
            if (params[i].conditions) {
                this._questConditions.set("conditions", this._modelData.createQuestCondition("conditions", params[i].conditions));
            }
            else {
                let offerQuestCondition: IOfferQuestCondition = this._modelData.createQuestCondition(params[i].name, params[i].params);
                if (offerQuestCondition) {
                    this._questConditions.set(params[i].name, offerQuestCondition);
                }
            }
        }
    }

    public setLogic(logic: OfferQuestConditionLogicEnum): void {
        if (logic) {
            this._logic = logic;
        }
        else {
            this._logic = OfferQuestConditionLogicEnum.AND;
        }
    }

    public toString(): string {
        let text: string = "Condition Container";
        for (let key of Array.from(this._questConditions.keys())) {
            let value: IOfferQuestCondition = this._questConditions.get(key);
            text += "\n   " + key + " --> " + value;
        }
        return text;
    }

    public get logic(): OfferQuestConditionLogicEnum {
        return this._logic;
    }

    public get conditionPassed(): boolean {
        let subCond: IOfferQuestCondition;
        switch (this._logic) {
            case OfferQuestConditionLogicEnum.AND:
                for (let subCond of Array.from(this._questConditions.values())) {
                    if (!subCond.conditionPassed) {
                        return false;
                    }
                }
                return true;

            case OfferQuestConditionLogicEnum.OR:
                for (let subCond of Array.from(this._questConditions.values())) {
                    if (subCond.conditionPassed) {
                        return true;
                    }
                }
                return false;

            case OfferQuestConditionLogicEnum.XOR:
                let onePassed: boolean = false;
                for (let subCond of Array.from(this._questConditions.values())) {
                    if (onePassed) {
                        if (subCond.conditionPassed) {
                            return false;
                        }
                    }
                    else {
                        if (subCond.conditionPassed) {
                            onePassed = true;
                        }
                    }
                }
                return onePassed;

            case OfferQuestConditionLogicEnum.NOT:
            default:
                // make no sense with more than one argument. do not use it, rewrite condition
                return false;
        }
    }

    public get conditionTextId(): string {
        return "QUEST CONDITION CONTAINER";	// todo: maybe here add all subconditions with logic string id
    }

    public get conditionTextReplacements(): any[] {
        return [];
    }

    public get questConditions(): Map<any, any> {
        return this._questConditions;
    }

    public dispose(): void {
        if (this._questConditions) {
            for (let offerQuestCondition of Array.from(this._questConditions.values())) {
                offerQuestCondition.dispose();
            }

            this._questConditions = null;
        }

        this._modelData = null;
    }
}
